import React, { useEffect, useState, lazy, Suspense } from "react";
import ReactGA from "react-ga4";
import ReactGAOld from "react-ga";
import { appData } from "./data/config";

import { analyticsEventsData as gseoOfferCustomWPAnalyticsEvents } from "./sites/gseo-offer-new-custom-wp/formData";
import { analyticsEventsData as gseoOfferPPCAnalyticsEvents } from "./sites/gseo-offer-ppc/formData";

const GSEO = lazy(() => import("./sites/gseo/Gseo"));
const GSEODev = lazy(() => import("./sites/gseo-dev/GseoDev"));
const GSEOHosting = lazy(() => import("./sites/gseo-hosting/GseoHosting"));
const GSEOHours = lazy(() => import("./sites/gseo-hours/GseoHours"));
const GSEOHoursDecline = lazy(() => import("./sites/gseo-hours-decline/GseoHours"));
const Cleaning4U = lazy(() => import("./sites/cleaning4u/Cleaning4U"));
const YaletownDentistry = lazy(() => import("./sites/yaletowndentistry/YaletownDentistry"));
const AlblasterJobs = lazy(() => import("./sites/alblaster-jobs/AlblasterJobs"));
const DigitalInns = lazy(() => import("./sites/digital-inns/DigitalInns"));
const GSEOReferral = lazy(() => import("./sites/gseo-referral/GseoReferral"));
const GSEOOfferCustomWP = lazy(() => import("./sites/gseo-offer-new-custom-wp/GSEOOfferCustomWP"));
const GSEOOfferPPC = lazy(() => import("./sites/gseo-offer-ppc/GSEOOfferPPC"));

// Import analyticsEventsData from each site's formData
// import { analyticsEventsData as gseoAnalyticsEvents } from "./sites/gseo/formData";
// import { analyticsEventsData as gseoDevAnalyticsEvents } from "./sites/gseo-dev/formData";
// import { analyticsEventsData as gseoHostingAnalyticsEvents } from "./sites/gseo-hosting/formData";
// import { analyticsEventsData as gseoHoursAnalyticsEvents } from "./sites/gseo-hours/formData";
// import { analyticsEventsData as gseoHoursDeclineAnalyticsEvents } from "./sites/gseo-hours-decline/formData";
// import { analyticsEventsData as cleaning4uAnalyticsEvents } from "./sites/cleaning4u/formData";
// import { analyticsEventsData as yaletownDentistryAnalyticsEvents } from "./sites/yaletowndentistry/formData";
// import { analyticsEventsData as alblasterJobsAnalyticsEvents } from "./sites/alblaster-jobs/formData";
// import { analyticsEventsData as digitalInnsAnalyticsEvents } from "./sites/digital-inns/formData";
// import { analyticsEventsData as gseoReferralAnalyticsEvents } from "./sites/gseo-referral/formData";


const API_KEYS = {
	RECAPTCHA: appData.gseoRecaptcha,
};
// const BING_TAG_ID = appData.bing_tag_id;

const API_ENDPOINTS = {};
if (process.env.NODE_ENV === "production") {
	// API_ENDPOINTS.test = `${appData.appUrl}/gseo-form-server/get/data`;
	// API_ENDPOINTS.mailer = `${appData.appUrl}/gseo-form-server/send/form_email`;
	// API_ENDPOINTS.recaptcha = `${appData.appUrl}/gseo-form-server/verify/recaptcha`;
	API_ENDPOINTS.test = "https://lead-form-api.guaranteedseo.com/get/data";
	API_ENDPOINTS.mailer = "https://lead-form-api.guaranteedseo.com/send/form_email";
	API_ENDPOINTS.recaptcha = "https://lead-form-api.guaranteedseo.com/verify/recaptcha";
} else {
	API_ENDPOINTS.test = "http://localhost:5055/get/data";
	API_ENDPOINTS.mailer = "http://localhost:5055/send/form_email";
	API_ENDPOINTS.recaptcha = "http://localhost:5055/verify/recaptcha";
}

const queryParams = new URLSearchParams(window.location.search);

// Default analytics event names - can be overridden in site-specific formData.js
const defaultAnalyticsEventsData = {
	formView: "lead_form1",
	formSubmitted: "form_submitted",
	formStep: "lead_form_step_",
};

// Map site clients to their analytics event configurations
const siteAnalyticsEventsMap = {
	// "gseolive": gseoAnalyticsEvents,
	// "gseodev": gseoDevAnalyticsEvents,
	// "gseo-hosting": gseoHostingAnalyticsEvents,
	// "gseo-hours": gseoHoursAnalyticsEvents,
	// "gseo-hours-decline": gseoHoursDeclineAnalyticsEvents,
	// "cleaning4u": cleaning4uAnalyticsEvents,
	// "yaletowndentistry": yaletownDentistryAnalyticsEvents,
	// "alblaster-jobs": alblasterJobsAnalyticsEvents,
	// "digital-inns": digitalInnsAnalyticsEvents,
	// "gseoreferral": gseoReferralAnalyticsEvents,
	"gseo-offer-new-custom-wp": gseoOfferCustomWPAnalyticsEvents,
	"gseo-offer-ppc": gseoOfferPPCAnalyticsEvents,
};

// Get analytics events for current site, fallback to default
const currentSiteAnalyticsEvents = siteAnalyticsEventsMap[appData.gseoClient] || defaultAnalyticsEventsData;

if (appData.ga4_id) {
	ReactGA.initialize(appData.ga4_id, {
		debug: false,
	});
}

if (appData.analyticsUA) {
	ReactGAOld.initialize(appData.analyticsUA);
	ReactGAOld.pageview(window.location.pathname + window.location.search);
	if (appData.gseoClient === "gseolive") {
		ReactGAOld.event({
			category: "Contact",
			action: "step-1",
		});
	}
}

const sendGAView = (page) => {
	ReactGA.send("pageview");
	ReactGA.event(currentSiteAnalyticsEvents.formView);
};

const sendGAEvent = (event_name, params = []) => {
	ReactGA.event(event_name);
	if (appData.analyticsUA && event_name === "form_submitted") {
		ReactGAOld.event({
			category: "Contact",
			action: "form-submission",
		});
	}
	if (appData.analyticsUA && event_name === "lead_form_step") {
		ReactGAOld.event({
			category: "Contact",
			action: "step-" + params[0],
		});
	}
};

const MainLoader = <div className='p-10 text-4xl text-center'>Loading...</div>;

const App = () => {
	const [gseoFormData, setGseoFormData] = useState({});
	const getActiveSite = (v) => {
		if (v === "gseolive") {
			return (
				<Suspense fallback={MainLoader}>
					<GSEO
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "gseodev") {
			return (
				<Suspense fallback={MainLoader}>
					<GSEODev
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "gseo-hosting") {
			return (
				<Suspense fallback={MainLoader}>
					<GSEOHosting
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "cleaning4u") {
			return (
				<Suspense fallback={MainLoader}>
					<Cleaning4U
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "yaletowndentistry") {
			return (
				<Suspense fallback={MainLoader}>
					<YaletownDentistry
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "gseo-hours") {
			return (
				<Suspense fallback={MainLoader}>
					<GSEOHours
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "gseo-hours-decline") {
			return (
				<Suspense fallback={MainLoader}>
					<GSEOHoursDecline
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "alblaster-jobs") {
			return (
				<Suspense fallback={MainLoader}>
					<AlblasterJobs
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						mainLoader={MainLoader}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "digital-inns") {
			return (
				<Suspense fallback={MainLoader}>
					<DigitalInns
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						mainLoader={MainLoader}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "gseoreferral") {
			return (
				<Suspense fallback={MainLoader}>
					<GSEOReferral
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						mainLoader={MainLoader}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "gseo-offer-new-custom-wp") {
			return (
				<Suspense fallback={MainLoader}>
					<GSEOOfferCustomWP
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						mainLoader={MainLoader}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else if (v === "gseo-offer-ppc") {
			return (
				<Suspense fallback={MainLoader}>
					<GSEOOfferPPC
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						mainLoader={MainLoader}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		} else {
			return (
				<Suspense fallback={MainLoader}>
					{/* <DigitalInns
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						mainLoader={MainLoader}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/> */}
					<GSEOReferral
						API_KEYS={API_KEYS}
						API_ENDPOINTS={API_ENDPOINTS}
						sendGAView={sendGAView}
						sendGAEvent={sendGAEvent}
						queryParams={queryParams}
						mainLoader={MainLoader}
						gseoFormData={gseoFormData}
						setGseoFormData={setGseoFormData}
					/>
				</Suspense>
			);
		}
	};

	useEffect(() => {
		const loadScriptByURL = (id, url, callback) => {
			const isScriptExist = document.getElementById(id);
			if (!isScriptExist) {
				var script = document.createElement("script");
				script.type = "text/javascript";
				script.src = url;
				script.id = id;
				script.onload = function () {
					if (callback) callback();
				};
				document.body.appendChild(script);
			}

			if (isScriptExist && callback) callback();
		};
		loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${API_KEYS.RECAPTCHA}`, function () {
			//console.log("Recaptcha Script loaded!");
		});

		// Google Tag Manager
		let gtmScript = null;
		let gtmNoscript = null;
		if (appData.tag_manager_id) {
			gtmScript = document.createElement('script');
			gtmScript.innerHTML = `
				(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
				new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
				})(window,document,'script','dataLayer','${appData.tag_manager_id}');
			`;
			document.head.appendChild(gtmScript);

			gtmNoscript = document.createElement('noscript');
			const gtmIframe = document.createElement('iframe');
			gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${appData.tag_manager_id}`;
			gtmIframe.height = '0';
			gtmIframe.width = '0';
			gtmIframe.style.display = 'none';
			gtmIframe.style.visibility = 'hidden';
			gtmNoscript.appendChild(gtmIframe);
			document.body.insertBefore(gtmNoscript, document.body.firstChild);
		}

		// Meta Pixel
		let metaPixelScript = null;
		let metaPixelNoscript = null;
		// if (appData.meta_pixel_id && !window.fbq) {
		// 	metaPixelScript = document.createElement('script');
		// 	metaPixelScript.innerHTML = `
		// 		!function(f,b,e,v,n,t,s)
		// 		{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
		// 		n.callMethod.apply(n,arguments):n.queue.push(arguments)};
		// 		if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
		// 		n.queue=[];t=b.createElement(e);t.async=!0;
		// 		t.src=v;s=b.getElementsByTagName(e)[0];
		// 		s.parentNode.insertBefore(t,s)}(window, document,'script',
		// 		'https://connect.facebook.net/en_US/fbevents.js');
		// 		fbq('init', '${appData.meta_pixel_id}');
		// 		fbq('track', 'PageView');
		// 	`;
		// 	document.head.appendChild(metaPixelScript);

		// 	metaPixelNoscript = document.createElement('noscript');
		// 	const metaPixelImg = document.createElement('img');
		// 	metaPixelImg.height = '1';
		// 	metaPixelImg.width = '1';
		// 	metaPixelImg.style.display = 'none';
		// 	metaPixelImg.src = `https://www.facebook.com/tr?id=${appData.meta_pixel_id}&ev=PageView&noscript=1`;
		// 	metaPixelNoscript.appendChild(metaPixelImg);
		// 	document.body.insertBefore(metaPixelNoscript, document.body.firstChild);
		// } else if (appData.meta_pixel_id && window.fbq) {
		// 	// Pixel already loaded, just track PageView
		// 	window.fbq('track', 'PageView');
		// }

		let bingScript = null;
		if (appData.gseoClient === "gseolive") {
			bingScript = document.createElement('script');
			const BING_TAG_ID= 163013672;
			bingScript.innerHTML = `
        (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"${BING_TAG_ID}"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");
      `;
			document.head.appendChild(bingScript);

			/*const noscript = document.createElement('noscript');
			noscript.innerHTML = `<img src="//bat.bing.com/action/0?ti=${BING_TAG_ID}&Ver=2" height="0" width="0" style="display:none; visibility: hidden;" />`;
			document.head.appendChild(noscript);*/
		}

		// Cleanup function for all scripts
		return () => {
			if (gtmScript && document.head.contains(gtmScript)) {
				document.head.removeChild(gtmScript);
			}
			if (gtmNoscript && document.body.contains(gtmNoscript)) {
				document.body.removeChild(gtmNoscript);
			}

			if (metaPixelScript && document.head.contains(metaPixelScript)) {
				document.head.removeChild(metaPixelScript);
			}
			if (metaPixelNoscript && document.body.contains(metaPixelNoscript)) {
				document.body.removeChild(metaPixelNoscript);
			}

			if (bingScript && document.head.contains(bingScript)) {
				document.head.removeChild(bingScript);
			}
		};
	}, []); // [] here = empty dependancies so it only loads once?? not 100%

	return <div>{getActiveSite(appData.gseoClient)}</div>;
};

export default App;
